import type { CheckboxProps } from '@heroui/react'
import { Checkbox } from '@heroui/react'
import type { FieldProps, FormikProps } from 'formik'
import { Field } from 'formik'
import { motion } from 'framer-motion'
import type { FC, ReactNode } from 'react'

export interface CheckboxFormikProps extends Omit<CheckboxProps, 'onChange' | 'isSelected'> {
  label: string | ReactNode
  classNameContainer: string
  name: string
}

interface FormValues {
  [key: string]: boolean
}

const CheckboxFormik: FC<CheckboxFormikProps> = ({ label, classNameContainer, ...props }) => {
  return (
    <Field name={props.name}>
      {({ field, meta, form }: FieldProps<boolean> & { form: FormikProps<FormValues> }) => {
        const isSelected = typeof field.value === 'boolean' ? field.value : false

        return (
          <motion.div className={classNameContainer}>
            <Checkbox
              onBlur={field.onBlur}
              {...props}
              errorMessage={meta.error && meta.touched ? meta.error : ''}
              isInvalid={Boolean(meta.error && meta.touched)}
              isSelected={isSelected}
              onChange={() => form.setFieldValue(field.name, !isSelected)}
            >
              {label}
            </Checkbox>
          </motion.div>
        )
      }}
    </Field>
  )
}

export default CheckboxFormik
